import { request } from '@/utils/request'
import providers from '@/utils/providers.js'

export default {
    async list(entityType, entityId) {
        const results = await request.get(`/api/manage/entityproviderids/${entityType}/${entityId}`)
        results.forEach(r => (r.providerName = providers[r.providerId]?.name ?? r.providerId.toString()))
        return results
    },
    unlinkProvider(id) {
        return request.delete(`/api/manage/entityproviderids/${id}`)
    },
    linkProvider(entityType, entityId, providerId, providerEntityId, sourceProfile, targetProfile) {
        var data = {
            entityType,
            entityId,
            providerId,
            providerEntityId,
            sourceProfile,
            targetProfile,
        }
        return request.post('/api/manage/entityproviderids', data)
    },
}
